import { css } from 'styled-system/css';

export const bookingRulesPopupStyle = {
	rulesModal: css({
		_mars: {
			color: 'black.2',
			'& li': {
				color: 'black.2',
			}
		},
	}),
	feedback: css({
		_mars: {
			bgColor: 'var(--s700)',
		}
	}),
	feedbackButton: css({
		_mars: {
			'&[data-selected="true"]': {
				color: 'booked.3',
			}
		},
	}),
}